import type { TrackedEvent } from './analytics'

let emit: ((event: TrackedEvent) => void) | null = null

/**
 * Hand the root event scope's emitter to code that runs outside React — Redux
 * thunks own the chat stream and the funding lifecycle, and cannot call hooks.
 * Set by `ProductEventEmitterBinding`.
 */
export const setProductEventEmitter = (
  next: ((event: TrackedEvent) => void) | null
) => {
  emit = next
}

/** No-op until a binding mounts, so telemetry never gates product behaviour. */
export const emitProductEvent = (event: TrackedEvent) => emit?.(event)
